<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5 ml-4">
        <li>
          <router-link to="/inventory/vendor-management" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditVendor") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card title no-shadow card-border>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.Code')"
            >
              <vs-input
                :label="$t('setup.label.Code')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="vendor.vendorCode"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider
              rules="required|alpha_spaces"
              v-slot="{ errors }"
              :name="$t('setup.label.Name')"
            >
              <vs-input
                :label="$t('setup.label.Name')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="vendor.vendorName"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider
              rules="required|alpha_spaces"
              v-slot="{ errors }"
              :name="$t('setup.label.ContactName')"
            >
              <vs-input
                :label="$t('setup.label.ContactName')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="vendor.contactName"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider
              rules="required|email"
              v-slot="{ errors }"
              :name="$t('setup.label.Email')"
            >
              <vs-input
                :label="$t('setup.label.Email')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="vendor.vendorEmailId"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <div class="dropdown-with-label">
              <small class="date-label font-semibold"
                >{{ $t("setup.label.Currency")
                }}<span class="required">*</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Currency')"
              >
                <v-select
                  v-model="vendor.vendorCurrency"
                  :options="currencyOptions"
                  :reduce="(obj) => obj.code"
                  label="code"
                  :placeholder="$t('setup.label.select_Currency')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option"
                    >{{ option.code }} -- {{ option.name }}</template
                  >
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required|digits:10"
              v-slot="{ errors }"
              :name="$t('setup.label.Mobile')"
            >
              <vs-input
                :label="$t('setup.label.Mobile')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="vendor.vendormobileNo"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider
              rules="required|digits:10"
              v-slot="{ errors }"
              :name="$t('setup.label.Landline')"
            >
              <vs-input
                :label="$t('setup.label.Landline')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="vendor.vendorLandlineNo"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.Address')"
            >
              <vs-input
                :label="$t('setup.label.Address')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="vendor.vendorAddress"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <div class="dropdown-with-label">
              <small class="date-label font-semibold"
                >{{ $t("setup.label.Country")
                }}<span class="required">*</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Country')"
              >
                <v-select
                  label="countryName"
                  v-model="vendor.vendorCountryId"
                  :options="countryData"
                  :reduce="(obj) => obj.id"
                  :placeholder="$t('setup.label.select_Country')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.countryName
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancelForm"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createVendor"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      // vendor: vendorEmptyObj,
      errorMessage: "",
      vendors: {},
      vendor: {
        vendorCode: "",
        vendorName: "",
        contactName: "",
        vendorEmailId: "",
        vendorCurrency: "",
        vendormobileNo: "",
        vendorLandlineNo: "",
        vendorAddress: "",
        vendorCountry: "",
      },
      countryData: [],
      country: "",
      currencyOptions: [],
      currency: "",
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  mounted() {
    // this.getVendorList()
    // this.createVendor()
  },
  computed: {
    ...mapState({
      vendorData: (state) => state.vendorManagement.vendor,
    }),
  },
  methods: {
    async getByIdVendor() {
      try {
        await this.$store.dispatch(
          "vendorManagement/fetchVendorByIdAction",
          this.id
        );

        this.vendor = this.vendorData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createVendor() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.vendor.locale = "en";
      this.vendor.vendorCountry = this.vendor.vendorCountryId;
      delete this.vendor.vendorCountryId;
      delete this.vendor.vendorCountryName;
      delete this.vendor.countryData;
      delete this.vendor.currencyOptions;
      try {
        await this.$store.dispatch("vendorManagement/updateVendorAction", {
          id: this.id,
          data: this.vendor,
        });

        this.cancelForm();

        this.$swal({
          title: "Success",
          icon: "success",
          text: "Vendor Updated Successfully!",
          type: "success",
        });
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    cancelForm() {
      this.$router.push(`/inventory/vendor-management`);
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getByIdVendor();
  },
  watch: {
    vendor(value) {
      this.countryData = value.countryData;
      this.currencyOptions = value.currencyOptions;
    },
  },
};
</script>
